import { config } from "@/config";
import { DiagramInfo } from "@/types/diagram";
import { useAuthHeaders } from "@/hooks/use-auth-headers";
import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api-client";

export async function getDiagrams(
  uuid: string,
  token: string
): Promise<{ data: DiagramInfo[]; total: number } | undefined> {
  const url = `${config.isometricApiUrl}/diagram?filters[uuid][eq]=${uuid}`;

  try {
    const response = await apiFetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    // Check if the response is ok (status code in the range 200-299)
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json(); // Parse the JSON response
  } catch (error) {
    console.error("Error:", error); // Handle errors
  }
}

export default function useGetDiagram(
  uuid: string,
  agent: string,
  enabled?: boolean
) {
  const { getAuthHeaders } = useAuthHeaders();

  return useQuery({
    queryKey: ["diagrams-uuid", uuid, agent],
    queryFn: () => {
      const headers = getAuthHeaders();
      const token = headers.Authorization.replace("Bearer ", "");
      return getDiagrams(uuid || "", token);
    },
    enabled: !!enabled,
  });
}
